module.exports = __webpack_public_path__ + "img/videoBgImg.7cca4981.png";